import axios from "axios";

const state = {
  categories: []
};

const getters = {
  allCategories: state => state.categories
};

const actions = {
  async fetchCategories({ commit }) {
    const response = await axios.get(`${process.env.VUE_APP_API}/categories`);

    commit("setCategories", response.data.data);
  }
};

const mutations = {
  setCategories: (state, categories) => (state.categories = categories)
};

export default {
  state,
  getters,
  actions,
  mutations
};
